export enum PatientListFilter {
    AllPatients = "allPatients",
    WithNights = "withNights",
    Activated = "activated",
    NonActivated = "nonActivated",
    Unshared = "unshared",
}
